module.exports = __webpack_public_path__ + "static/media/esports-page-grid-1.df985284.jpg";